import { render, staticRenderFns } from "./HomePart5.vue?vue&type=template&id=0d115692&scoped=true&"
import script from "./HomePart5.vue?vue&type=script&lang=js&"
export * from "./HomePart5.vue?vue&type=script&lang=js&"
import style0 from "./HomePart5.vue?vue&type=style&index=0&id=0d115692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d115692",
  null
  
)

export default component.exports